export default {
  heading: 'Din, serif',
  body: 'Montserrat, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Playfair Display, serif',
  googleFonts: ['Montserrat:100,200,300,400,500,600,700,800,900', 'Playfair Display:400,500,600,700,800,900'],
  customFamilies: ['Din'],
  customUrls: ['https://www.gonation.biz/fonts/din/din.css']
}
